import React, { useEffect } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { useUserAuth } from '../../providers/auth';
import { apiHost } from '@pv/common/api';
import { isSafeReturnPath } from '@pv/common/utils';

const API_HOST = apiHost(process.env.REACT_APP_PV_ENV);

export default () => {
  const navigate = useNavigate();
  const { user } = useUserAuth();
  const [searchParams, _] = useSearchParams();
  const returnTo = searchParams.get('return_to');

  useEffect(() => {
    if (user) {
      // return_to comes straight from the URL. Only follow a same-origin path;
      // anything else (absolute URL, `//host`, `@host`, `.host`) would leave
      // the site after sign-in.
      if (isSafeReturnPath(returnTo)) {
        window.location.replace(`${API_HOST}${returnTo}`);
      } else {
        navigate('/');
      }
    }
  }, [user]);

  if (user) {
    return null;
  }

  return <Outlet />;
};
